var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.answers),function(answer,index){return _c('p',{key:index,staticClass:"mb-25"},[_c('b-radio',{attrs:{"value":_vm.value,"size":"is-small","native-value":answer.value},on:{"input":_vm.handleInput}},[_vm._v(_vm._s(answer.label))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }